import React from "react";
import styles from "../styles/campaignNotifications.module.scss";

export default function CampaignCopyCell({ title, message }) {
  const hasCopy = Boolean(title || message);

  if (!hasCopy) {
    return <span className={styles.copyMessage}>—</span>;
  }

  return (
    <div className={styles.copyCell}>
      <div className={styles.copyTitle}>{title || "Untitled"}</div>
      {message ? <div className={styles.copyMessage}>{message}</div> : null}
    </div>
  );
}
